<div class="flex" style="margin-top: 8px;">
  <div class="card w-full">
    <div class="p-datatable p-component p-datatable-hoverable-rows">
      <div class="p-datatable-header">
        <div class="flex flex-column sm:flex-row justify-content-between">
          <div class="flex flex-column md:flex-row">
            <button
              [label]="'common.new' | transloco"
              pButton
              pRipple
              class="md:mr-2 p-button-primary mb-2 md:mb-0"
              routerLink="default-measurement-types/new"
              icon="pi pi-plus"
            ></button>
            <!--<button
              [label]="'common.delete' | transloco"
              [disabled]="selected.length == 0"
              (click)="confirmAndDeleteSelected()"
              pButton
              pRipple
              class="p-button-danger mb-2 sm:mb-0"
              icon="pi pi-trash"
            ></button>-->
          </div>
          <div *ngIf="!filtersFilled" class="flex flex-column md:flex-row justify-content-end">
            <button
              [label]="'common.filters' | transloco"
              (click)="filtersVisible = !filtersVisible"
              pButton
              class="p-button-secondary"
              icon="pi pi-sliders-h"
            ></button>
          </div>
          <div *ngIf="filtersFilled" class="flex flex-column md:flex-row justify-content-end">
            <button
              [label]="'common.filters' | transloco"
              (click)="filtersVisible = !filtersVisible"
              pButton
              class="p-button-secondary filtersFilled"
              icon="pi pi-filter"
            ></button>
          </div>
        </div>
      </div>
      <p-table
        [(selection)]="selected"
        [(first)]="first"
        [(rows)]="rows"
        [value]="types"
        [totalRecords]="totalTypes"
        [responsive]="true"
        [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
        [paginator]="true"
        [rowsPerPageOptions]="[10,25,50]"
        [lazy]="true"
        (onLazyLoad)="onPageChange($event)"
        styleClass="p-datatable-striped"
        sortField="sensor"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="selection-column-width"></th>
            <th pSortableColumn="sensor">
              {{'attribute.sensor' | transloco}}<p-sortIcon field="sensor"></p-sortIcon></th>
            <th pSortableColumn="unit">
              {{'attribute.unit' | transloco}}<p-sortIcon field="unit"></p-sortIcon></th>
            <th pSortableColumn="dataType">
              {{'attribute.dataType' | transloco}}<p-sortIcon field="dataType"></p-sortIcon></th>
            <th class="w-10rem">
              {{'common.actions' | transloco}}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-type>
          <tr *ngIf="!loadingTypes" class="fadein">
            <td>
              <span class="p-column-title bold">{{'common.select' | transloco}}</span>
              <p-tableCheckbox [value]="type"></p-tableCheckbox>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.sensor' | transloco}}</span>
              {{type.sensor}}
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.unit' | transloco}}</span>
              {{type.unit}}
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.dataType' | transloco}}</span>
              {{type.dataType ? (('forms.sensorType.' + type.dataType) | transloco) : ''}}
            </td>
            <td>
              <span class="p-column-title bold">{{'common.actions' | transloco}}</span>
              <div class="flex justify-content-end">
                <button
                  [routerLink]="['default-measurement-types', type.sensor, type.unit, 'edit']"
                  pButton
                  pRipple
                  class="p-button-rounded btn-primary-light mr-2"
                  icon="pi pi-pencil"
                ></button>
                <!--<button
                  (click)="confirmAndDelete(type)"
                  pButton
                  pRipple
                  class="p-button-rounded btn-danger-light"
                  icon="pi pi-trash"
                ></button>-->
              </div>
            </td>
          </tr>
          <tr *ngIf="loadingTypes" class="fadein animation-delay-200 animation-fill-forwards no-opacity">
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="flex align-items-center justify-content-between" *ngIf="totalTypes == 0">
            {{'pagination.empty' | transloco}}
          </div>
          <div class="flex align-items-center justify-content-between" *ngIf="totalTypes > 0">
            {{'pagination.showing' | transloco}} {{first+1}}
            {{'pagination.to' | transloco}} {{(first+rows) >= totalTypes ? totalTypes : (first+rows)}}
            {{'pagination.of' | transloco}} {{totalTypes}}
            {{(totalTypes > 1 ? 'pagination.entries':'pagination.entry') | transloco}}
          </div>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>


<p-sidebar [(visible)]="filtersVisible" position="right" [baseZIndex]="10000" [style]="{'width':'25em'}">
  <h2 style="margin-left: 10px;">{{'common.filters' | transloco}}</h2>
  <div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="sensor">{{'attribute.name' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input
          [(ngModel)]="currentFilters.sensor"
          [focus]="filtersVisible"
          (keyup.enter)="filtersVisible = false; applyFilters()"
          pInputText
          appAutoFocus
          class="w-full"
          id="sensor"
          type="text"
        >
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="unit">{{'attribute.unit' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input
          [(ngModel)]="currentFilters.unit"
          (keyup.enter)="filtersVisible = false; applyFilters()"
          pInputText
          class="w-full"
          id="unit"
          type="text"
        >
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="dataType">{{'attribute.dataType' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-dropdown
          [(ngModel)]="currentFilters.dataType"
          *ngIf="dataTypes"
          [placeholder]="'select.generic' | transloco"
          [filter]="false"
          [options]="dataTypes"
          styleClass="w-full"
          id="dataType"
          appendTo="body"
        >
          <ng-template let-dataType pTemplate="selectedItem"> {{dataType.label | transloco}} </ng-template>
          <ng-template let-dataType pTemplate="item"> {{dataType.label | transloco}} </ng-template>
        </p-dropdown>
      </div>
    </div>
    <div class="col-12">
      <p-button
        [label]="'common.filter' | transloco"
        [disabled]="!(
          currentFilters.sensor ||
          currentFilters.unit ||
          currentFilters.dataType
        )"
        (onClick)="filtersVisible = false; applyFilters()"
        styleClass="p-button-primary mx-2 mt-2"
        type="button"
      ></p-button>
      <p-button
        [label]="'common.clear' | transloco"
        (click)="resetFilters(); filtersVisible = false;"
        styleClass="p-button-danger"
        type="button"
      ></p-button>
    </div>
  </div>
</p-sidebar>
